'use client';

import { cn } from '~/lib/cn';

interface Props {
    isLoading?: boolean;
    className?: string;
}

/** The thin green line that runs across a table while it loads. */
const LoadingBar = ({ isLoading, className }: Props) => (
    <div
        aria-hidden="true"
        className={cn(
            isLoading && 'before:tw-animate-[moving_1s_ease-in-out_infinite]',
            "tw-relative tw-h-[1px] tw-w-full before:tw-absolute before:tw-left-0 before:tw-top-0 before:tw-h-full before:tw-w-[0%] before:tw-bg-success before:tw-content-['']",
            className
        )}
    >
        <style jsx>{`
            @keyframes moving {
                50% {
                    width: 100%;
                }

                100% {
                    width: 0;
                    right: 0;
                    left: unset;
                }
            }
        `}</style>
    </div>
);

export default LoadingBar;
